'use strict';

export default [
  'ResourceService',
  class OrderService {
    constructor(resourceService) {
      this._resourceService = resourceService;
      this._API_BASE = '/orders';
    }

    getByOrderNumberAndZipCode(orderNumber, zipCode) {
      if (!orderNumber || !zipCode) return null;
      let query = `zip_code=${zipCode}`;
      if (typeof orderNumber == 'string' && orderNumber.indexOf('#') == 0) {
        orderNumber = orderNumber.substring(1);
      }
      return this._resourceService.get(`${this._API_BASE}/${orderNumber}?${query}`);
    }

    getBaseOrder(orderNumber, zipCode) {
      if (!orderNumber || !zipCode) return this._resourceService.errorPromise('order:getBaseOrder: missing parameters');
      let query = `zip_code=${zipCode}`;
      return this._resourceService.get(`${this._API_BASE}/${orderNumber}/base?${query}`);
    }

    sendReminder(email) {
      if (!email) return null;
      let data = {
        'email_address': email
      };
      return this._resourceService.post(`${this._API_BASE}/remind`, data);
    }

    getTrackingHistoryByOrderNumber(orderNumber) {
      if (!orderNumber) return null;
      return this._resourceService.get(`${this._API_BASE}/${orderNumber}/fulfillment/history`);
    }

    getShipmentDetailsById(id) {
      if (!id) return null;
      return this._resourceService.get(`${this._API_BASE}/${id}/fulfillment/shipment`);
    }

    getShipmentDetailsByOrderNumber(orderNumber) {
      if (!orderNumber) return null;
      return this._resourceService.get(`${this._API_BASE}/${orderNumber}/fulfillment/shipment`);
    }

    getFulfillmentDatesByOrderNumber(orderNumber) {
      if (!orderNumber) return null;
      return this._resourceService.get(`${this._API_BASE}/${orderNumber}/fulfillment/estimate`);
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/api-services/order-service.js